import React from 'react'
import type { CellProps } from 'react-table'
import LinkCell from '../../Generics/GenericLinkCell'
import type { VehicleStatsByCompany } from '../../../../generated/graphql'

export const Account = ({
    row: {
        original: { accountId },
    },
    cell: { value },
}: CellProps<VehicleStatsByCompany>): React.ReactNode =>
    accountId && <LinkCell href={`/details/companies?id=${accountId}`}>{value}</LinkCell>
